<template>
  <section class="collection-page">
    <header class="collection-header">
      <div><span class="eyebrow">Comunicação</span><h2>Campanhas</h2><p>Crie, acompanhe e otimize seus envios em um só lugar.</p></div>
      <router-link :to="{ name: 'CampaignNew' }" class="button primary"><i class="fas fa-plus"></i> Nova campanha</router-link>
    </header>

    <div class="collection-toolbar">
      <div class="result-count"><span>{{ totalCampaigns | number }}</span> campanhas encontradas</div>
      <paginate v-if="totalPages > 1" :containerClass="'pagination'" :page-count="totalPages" v-model="page" :page-range="5" :click-handler="clickCallback" :prev-text="'Anterior'" :next-text="'Próxima'" />
    </div>

    <div v-if="loading" class="loading-card"><content-loading><fake-line height="30" /><fake-line height="30" /><fake-line height="30" /><fake-line height="30" /></content-loading></div>
    <ul v-else-if="campaigns.length" class="collection-list">
      <li v-for="camp in campaigns" :key="camp.id" class="collection-card">
        <div class="item-identity"><div class="item-icon"><i class="fas fa-paper-plane"></i></div><div><h3>{{ camp.name }}</h3><span>{{ camp.campaign_type }}</span></div></div>
        <div class="item-metrics">
          <div><span>Status</span><strong class="status-pill" :class="'status-' + camp.status.toLowerCase()">{{ decodeStatus(camp.status) }}</strong></div>
          <div><span>Contatos</span><strong v-if="camp.totalContacts !== undefined">{{ camp.totalContacts | number }}</strong><span v-else class="metric-loader" role="status" aria-label="Carregando contatos"></span></div>
          <div><span>Envios</span><strong v-if="camp.reportContact !== undefined && ['PROGRESS', 'DONE'].includes(camp.status)">{{ camp.reportContact | number }}</strong><strong v-else>—</strong></div>
        </div>
        <div class="item-actions">
          <button v-if="!camp.scheduling && camp.status === 'STOP'" class="action-button primary-action" title="Iniciar campanha" @click="updateStatus(camp, 'ACTIVE')"><i class="fas fa-play"></i></button>
          <button v-else-if="!camp.scheduling && ['ACTIVE', 'PROGRESS'].includes(camp.status)" class="action-button primary-action" title="Pausar campanha" @click="updateStatus(camp, 'STOP')"><i class="fas fa-pause"></i></button>
          <button v-else-if="camp.scheduling" class="action-button primary-action" title="Campanha agendada" @click="alertScheduling(camp)"><i class="far fa-calendar"></i></button>
          <router-link :to="{ name: 'CampaignDetail', params: { campaign_id: camp.id } }" class="action-button" title="Ver relatório"><i class="fas fa-chart-line"></i></router-link>
          <router-link :to="{ name: 'CampaignEdit', params: { campaign_id: camp.id } }" class="action-button" title="Editar"><i class="far fa-edit"></i></router-link>
          <button class="action-button" title="Duplicar" @click="openModalDuplicate(camp.id)"><i class="far fa-copy"></i></button>
          <button class="action-button danger-action" title="Excluir" @click="openModalDelete(camp.id)"><i class="far fa-trash-alt"></i></button>
        </div>
      </li>
    </ul>
    <div v-else class="empty-state"><div class="empty-icon"><i class="far fa-paper-plane"></i></div><h3>Sua primeira campanha começa aqui</h3><p>Crie uma campanha para se comunicar com seus contatos.</p><router-link :to="{ name: 'CampaignNew' }" class="button primary"><i class="fas fa-plus"></i> Criar campanha</router-link></div>
    <div v-if="!loading && totalPages > 1" class="bottom-pagination"><paginate :containerClass="'pagination'" :page-count="totalPages" v-model="page" :page-range="5" :click-handler="clickCallback" :prev-text="'Anterior'" :next-text="'Próxima'" /></div>
    <!-- modal confirm delete -->
    <modal-confirm
      :show="showDeleteModal"
      description="Você tem certeza que deseja deletar essa campanha?"
      @cancel="
        showDeleteModal = false;
        selectModalDelete = null;
      "
      @accept="removeCampaign(selectModalDelete)"
    ></modal-confirm>

    <!-- modal confirm duplicate -->
      <modal-confirm
      :show="showDuplicateModal"
      description="Você tem certeza que deseja duplicar essa campanha?"
      @cancel="
        showDuplicateModal = false;
        selectedModalDuplicate = null;
      "
      @accept="duplicateCampaign(selectedModalDuplicate)"
    ></modal-confirm>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");

import { 
  getCampaigns,
  updateCampaign,
  duplicateCampaign,
  removeCampaign,
  getCampaignContactReport
} from "@/services/campaign";

import { 
  getContacts,
} from "@/services/contact";



import ModalConfirm from "@/components/modal/ModalConfirm";


export default {
  name: "campaigns",
  components: { 
    ModalConfirm
  },
  data() {
    return {
      loading: false,
      showDeleteModal: false,
      selectModalDelete: null,
      showDuplicateModal: false,
      selectedModalDuplicate: null,
      filters: {
        data: {},
        list: {},
      },
      campaigns: [],
      totalCampaigns: 1,
      offset: 20,
      page: 1,
    };
  },
  mounted() {
    this.getCampaigns();
  },
  computed: {
    isEmpty() {
      // return !this.loading && this.products && this.products.length === 0;
      return this.totalCampaigns === 0 && !this.loading;
    },
    totalPages() {
      let valueMode = this.totalCampaigns % this.offset;
      let value = this.totalCampaigns / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
  },
  watch: {
    "page": {
      handler() {
        this.contacts = [];
        this.getCampaigns();
      }
    }
  },
  methods: {
    duplicateCampaign(campId) {
      this.showDuplicateModal = false
      this.selectedModalDuplicate = null
      duplicateCampaign(campId)
      .then((result)=> {
        this.campaigns.unshift(result)

        this.$toast.success({
          title:'Sucesso',
          message:'Campanha duplicada com sucesso'
        })
      })
      .catch(() => {
        this.$toast.error({
          title:'Erro',
          message:'Ocorreu algum problema'
        })
      })
    },
    decodeStatus(status) {
      let _map = {
        'ACTIVE': 'ATIVA',
        'STOP': 'PAUSADA',
        'PROGRESS': 'DISPARANDO',
        'SHEEDULE': 'AGENDADA',
        'DONE': 'FINALIZADA',
      }

      return _map[status] || status
    },
    updateStatus(camp, newStatus) {
      this.updateCampaign(camp, newStatus)
    },
    alertScheduling(camp) {
      this.$toast.success({
        title:'Sucesso',
        message:`Sua campanha tem o disparo agendado! Para: ${camp.scheduling}`
      })
    },
    openModalDelete(campId) {
      this.showDeleteModal = true
      this.selectModalDelete = campId
    },
    openModalDuplicate(campId) {
      this.showDuplicateModal = true
      this.selectedModalDuplicate = campId
    },
    removeCampaign(campId) {
      this.showDeleteModal = false
      this.selectModalDelete = null

      removeCampaign(campId)
        .then(() => {
          this.campaigns = this.campaigns.filter(c => c.id != campId)

          this.$toast.success({
            title:'Sucesso',
            message:'Campanha removido com sucesso'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao remover campanha'
          })
        })
    },
    getCampaigns() {
      this.loading = true;
      let params = {
        page: this.page,
        offset: this.offset,
      };
      getCampaigns(params)
        .then((result) => {
          this.campaigns = result.campaigns.map((p) => {
            return Object.assign({ 
              totalContacts: undefined,
              totalSends: undefined,
            }, p)
          });
          this.totalCampaigns = result.total
          // get contacts
          this.campaigns.forEach(camp => {
            this.getContacts(camp)
            this.getCampaignContactReport(camp)
          })
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          // this.$toast.error({
          //   title: "Erro",
          //   message: "Ocorreu um problema ao buscar campanhas",
          // });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateCampaign(camp, newStatus) {
      let params =  {
          status: newStatus
      }
      updateCampaign(camp.id, params)
        .then(() => {
          if (newStatus === 'PROGRESS') {
            this.$toast.success({
              title:'Sucesso',
              message:'Disparo iniciado da campanha.'
            })
          } else {
            this.$toast.success({
              title:'Sucesso',
              message:'Campanha Pausada'
            })
          }

          camp.status = newStatus
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    getContacts(camp) {
      let params = {
        page: 1,
        offset: 1,
        tag: camp.contact_tag_id,
        list: camp.contact_list_id,
        limite_date: camp.limite_date,
        limite_date_before: camp.limite_date_before,
      };
      getContacts(params)
        .then((result) => {
          camp.totalContacts = result.total
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          // this.$toast.error({
          //   title: "Erro",
          //   message: "Ocorreu um problema ao buscar total de contatos",
          // });
        })
    },
    getCampaignContactReport(camp) {
      getCampaignContactReport(camp.id)
        .then((result) => {
          camp.reportContact = result.total
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          // this.$toast.error({
          //   title: "Erro",
          //   message: "Ocorreu um problema ao buscar contatos que já foram enviados",
          // });
        })
    },

  },
};
</script>

<style lang="scss" scoped>
@import "../collection-page";
</style>
